<div class="counter-wrapper">
  <span class="minus" [ngClass]="{'disable-btn': disableMinBtn}" (click)="subtract()">
    <i class="fa fa-minus"></i>
  </span>
  <span class="plus" [ngClass]="{'disable-btn': disableMaxBtn}" (click)="add()">
    <i class="fa fa-plus"></i>
  </span>
</div>
